"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRemoveProfileForCompany = exports.useSetProfileForCompany = exports.getProfilesQuery = exports.requestProfilesQuery = void 0;
const react_query_1 = require("@tanstack/react-query");
const requestProfilesRepository_1 = __importDefault(require("../repositories/requestProfilesRepository"));
const query_keys_1 = require("./query-keys");
const requestProfilesQuery = (companyId, isCardRequest = false) => (0, react_query_1.queryOptions)({
    queryKey: [query_keys_1.requestProfileKeys.getRequestProfilesForCompany, companyId],
    queryFn: () => requestProfilesRepository_1.default.getRequestProfilesForCompany({ companyId }),
    enabled: !!companyId && Boolean(isCardRequest),
});
exports.requestProfilesQuery = requestProfilesQuery;
const getProfilesQuery = () => ({
    queryKey: [query_keys_1.requestProfileKeys.getProfiles],
    queryFn: requestProfilesRepository_1.default.getProfiles,
});
exports.getProfilesQuery = getProfilesQuery;
const useSetProfileForCompany = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: requestProfilesRepository_1.default.setProfileForCompany,
    });
};
exports.useSetProfileForCompany = useSetProfileForCompany;
const useRemoveProfileForCompany = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: requestProfilesRepository_1.default.removeProfileFromCompany,
    });
};
exports.useRemoveProfileForCompany = useRemoveProfileForCompany;
